import { createContext, type Dispatch, type ReactNode } from "react";
import { CollapsedEmployeesGroups } from "@/pages/human-resources/time-management/schedules/site-schedule/grouped-rows/collapsing/CollapsedEmployeesGroups.ts";
import {
  type CollapsedEmployeesGroupsAction,
  collapsedEmployeesGroupsReducer,
} from "@/pages/human-resources/time-management/schedules/site-schedule/grouped-rows/collapsing/collapsedEmployeesGroupsReducer.ts";
import { useImmerReducer } from "use-immer";

// eslint-disable-next-line react-refresh/only-export-components
export const CollapsedEmployeesGroupsContext = createContext<
  CollapsedEmployeesGroups | undefined
>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export const CollapsedEmployeesGroupsDispatchContext = createContext<
  Dispatch<CollapsedEmployeesGroupsAction> | undefined
>(undefined);

export function CollapsedEmployeesGroupsProvider(props: {
  children: ReactNode;
}): ReactNode {
  const [collapsedGroups, dispatch] = useImmerReducer(
    collapsedEmployeesGroupsReducer,
    new CollapsedEmployeesGroups(),
  );
  return (
    <CollapsedEmployeesGroupsContext.Provider value={collapsedGroups}>
      <CollapsedEmployeesGroupsDispatchContext.Provider value={dispatch}>
        {props.children}
      </CollapsedEmployeesGroupsDispatchContext.Provider>
    </CollapsedEmployeesGroupsContext.Provider>
  );
}
